import { createSlice } from "@reduxjs/toolkit";

const initialCategory = {
  category: ""
};

const initialOccupationCategoriesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  category: initialCategory
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const occupationCategorySlice = createSlice({
  name: "occupationCategories",
  initialState: initialOccupationCategoriesState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getCategories
    categoriesFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    //getCategory
    categoryFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.category = action.payload.entity;
    },
    //completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    //cleanCategoriesState
    categoriesStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.category = initialCategory;
    }
  }
});